import React, { useState, useEffect, useMemo } from 'react'
import { formFields, platformConfig, statusOptions } from './constant';
import { handleFieldError } from '../../../utils/form-validation';
import { useDispatch, useSelector } from "react-redux";
import _, { get } from 'lodash';
import SelectNew from '../../FormElements/SelectNew';
import ToastModal from "../../ToastModal";
import GoogleAdwordsAccount from '../../NewSeat/GoogleAdwords';
import DV360Account from '../../NewSeat/DV360';
import MetaAccount from '../../NewSeat/Meta';

import { isApiCallSuccess, isTenantDemoAdvertiser } from '../../../selectors';
import { withRouter } from 'react-router-dom';
import { useFetchPlatformData } from "../../../hooks/useFetchPlatformData";
import { postThirdPartyLoginUrlAction, postThirdPartyLoginVerificationAction, postAddThirdPartySeatAction, postAdvertiserPageListAction } from '../../../actions';
import { thirdPartyAccountAction } from '../../../actions/thirdPartyAccount';
import adwords from '../../../assets/images/platformWhiteBgIcons/1x-Icons/adwardsLogoWhiteBg.png';
import meta from '../../../assets/images/platformWhiteBgIcons/1x-Icons/metaLogoWhiteBg.png';
import dv360 from '../../../assets/images/platformWhiteBgIcons/1x-Icons/dv360LogoWhiteBg.png';
import tiktok from '../../../assets/images/platformWhiteBgIcons/1x-Icons/tiktokLogoWhiteBg.png';
import ion from '../../../assets/images/platformWhiteBgIcons/1x-Icons/ionLogoWhiteBg.png';
import { message } from 'antd';
import { infoMessages } from '../../../constants/demo/constant';

const platformImages = {
    [platformConfig.google]: adwords,
    [platformConfig.meta]: meta,
    [platformConfig.dv360]: dv360,
    [platformConfig.tiktok]: tiktok,
    [platformConfig.ion]: ion
};

const PlatformAccount = ({ key, selectAdvertisers = false, accounts, platformData, platformKey, props, resignInSeatData }) => {

    if (!platformData) {
        return null;
    }

    let platform = platformData.find(item => item.key == platformKey);

    const showPlatformAccount = (accounts, platform) => {
        const platformComponent = {
            [platformConfig.google]: GoogleAdwordsAccount,
            [platformConfig.dv360]: DV360Account,
            [platformConfig.meta]: MetaAccount
        };

        const Platform = platformComponent[platform];
        return <Platform accounts={accounts} platform={platform} resignInSeatData={resignInSeatData} />
    }

    return (
        <div className='px-2'>
            <div className="mx-4 border rounded px-0 mb-4">
                <div className="card bg-light"></div>

                {platform && <div style={{ backgroundColor: '#EBF1FA' }} className="row m-0">
                    <div className="col px-0">
                        <div className="d-flex align-items-center rounded border-0 p-2">
                            <img src={platformImages[platform.value]} alt={platform}
                                className="rounded-circle"
                                style={{ maxWidth: '100%', maxHeight: '100%' }}
                            />
                            <div style={{ fontSize: 16, color: '' }} className="text-dark pl-2">{platform.value}</div>
                        </div>
                    </div>
                </div>
                }

                {platform && showPlatformAccount(accounts, platform.value)}
            </div>
        </div>
    )
}

function index({ onClose, onSave, props, preservePageState, showLoading, resignInSeatData }) {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({ status: 1 });
    const [accounts, setAccounts] = useState([]);
    let platformData = useFetchPlatformData();

    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });

    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const thirdPartyAccount = useSelector(state => get(state, 'app.thirdPartyAccount', {}));

    const dispatch = useDispatch();

    const isDemoAdvertiser = useMemo(() => {
        return isTenantDemoAdvertiser(tenantId);
    }, [tenantId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
    };

    const getPlatformGenerateUrlParams = (platform) => {
        if (platform.toLowerCase() == 'google ads') {
            return { param: 'ads', requestBodyKey: 'adwordsLoginRequest' };
        } else if (platform.toLowerCase() == 'dv360') {
            return { param: 'dv360', requestBodyKey: 'dv360Verification' };
        } else if (platform.toLowerCase() == 'tiktok') {
            return { param: 'ads', requestBodyKey: 'adwordsLoginRequest' };
        } else if (platform.toLowerCase() == 'meta') {
            return { param: 'fb', requestBodyKey: 'loginRequest' };
        } else {
            return { param: '', requestBodyKey: '' };
        }
    };

    const getPlatformVerificationUrlParams = (platform) => {
        if (platform.toLowerCase() == 'google ads') {
            return { param: 'ads', requestBodyKey: 'adwordsVerification' };
        } else if (platform.toLowerCase() == 'dv360') {
            return { param: 'dv360', requestBodyKey: 'dv360Verification' };
        } else if (platform.toLowerCase() == 'tiktok') {
            return { param: 'ads', requestBodyKey: 'adwordsLoginRequest' };
        } else if (platform.toLowerCase() == 'meta') {
            return { param: 'fb', requestBodyKey: 'loginRequest' };
        } else {
            return { param: '', requestBodyKey: '' };
        }
    };

    const getLoginUrl = async (params, payload) => {
        try {
            let loginUrl;
            await dispatch(postThirdPartyLoginUrlAction({ tenantId, authToken, userId, params, payload }))
                .then((data) => {
                    const { responseCode: { msg, status = '' }, responseObj } = data;
                    if (status.toLowerCase() == "success" && responseObj && Object.keys(responseObj).length > 0) {
                        loginUrl = responseObj.url;
                    }
                }).catch((error) => {
                    console.error(error);
                });
            return loginUrl;
        } catch (error) {
            console.log(error);
        }
    };

    const verifyLoginCallbackUrl = async (params, payload) => {
        try {
            let loginVerificationData;
            await dispatch(postThirdPartyLoginVerificationAction({ tenantId, authToken, userId, params, payload }))
                .then((data) => {
                    const { responseCode: { msg, status = '' }, response } = data;
                    if (isApiCallSuccess(status) && response && response.length > 0) {
                        loginVerificationData = response;
                    } else {
                        toast(status, msg);
                    }
                }).catch((error) => {
                    console.error(error);
                });
            return loginVerificationData;
        } catch (error) {
            console.log(error);
        }
    }

    const generatePlatformUrl = async () => {
        if (isDemoAdvertiser) {
            message.info(infoMessages.seatResignin)
            return;
        }

        try {
            let platform = platformData.find(item => item.key == resignInSeatData.platformId);
            const { param, requestBodyKey } = getPlatformGenerateUrlParams(platform.value);
            let payload = {
                [requestBodyKey]: {
                    callbackUrl: window.location.href
                    // callbackUrl: `https://bekistage.torcai.com/atd/admin/connection`
                }
            };
            let loginUrl = await getLoginUrl({ platform: param }, payload);
            // console.log(loginUrl);
            if (loginUrl) {
                let data = { platform: platform.value, platformKey: platform.key };
                localStorage.setItem('thirdPartyLoginData', JSON.stringify(data));
                preservePageState('resignIn');
                window.location.href = loginUrl;
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleVerification = async (callbackUrl) => {
        try {
            showLoading(true);
            let url = new URL(callbackUrl);
            let params = url.searchParams;
            let paramsObj = {};
            for (let pair of params.entries()) {
                paramsObj[pair[0]] = pair[1];
            }
            let thirdPartyLoginData = JSON.parse(localStorage.getItem('thirdPartyLoginData'));
            const { param, requestBodyKey } = getPlatformVerificationUrlParams(thirdPartyLoginData.platform);
            let payload = {
                [requestBodyKey]: {
                    accessCode: paramsObj.code,
                    ...paramsObj,
                    callbackUrl: window.location.href,
                    // callbackUrl: `https://bekistage.torcai.com/atd/admin/connection`,
                    advertiserId: tenantId
                }
            };
            let loginAccountData = await verifyLoginCallbackUrl({ platform: param }, payload);
            // console.log(loginAccountData, 'loginAccountData');
            if (thirdPartyLoginData.platform.toLowerCase() == 'google ads' || thirdPartyLoginData.platform.toLowerCase() == 'dv360' || thirdPartyLoginData.platform.toLowerCase() == 'meta') {
                if (loginAccountData && Array.isArray(loginAccountData) && loginAccountData.length > 0) {
                    setAccounts(loginAccountData);
                }
            } else {
            }
            localStorage.removeItem("thirdPartyLoginData");
            localStorage.removeItem("thirdPartyCallbackUrl");
            showLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const updateMetaSeatPages = async (payload) => {
        let params = { addup: 'auto' };
        await dispatch(postAdvertiserPageListAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { status }, response } = data;
                if (status.toLowerCase() == "success") {
                    console.log("Fb pages updated successfully!");
                } else {
                    console.log("Fb pages updation failed!");
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const saveMappedThirdPartyAccount = async () => {

        if (isDemoAdvertiser) {
            message.info(infoMessages.seatResignin)
            return
        }

        try {
            if (resignInSeatData) {
                let params = { addup: resignInSeatData.id };
                let payload = {
                    thirdPartySeatRequest: {
                        ...resignInSeatData,
                        isRecActive: Number(form.status),
                        token: thirdPartyAccount.account.token
                    }
                };
                const platform = findPlatform(platformData, Number(form.platform));
                const isPlatformMeta = platform ? platform.toLowerCase() === platformConfig.meta.toLowerCase() : false;

                if (resignInSeatData['pages']) {
                    payload['thirdPartySeatRequest']['pages'] = thirdPartyAccount.account['pages'] && thirdPartyAccount['account']['pages'].length > 0 ? thirdPartyAccount['account']['pages'] : [];
                }

                await dispatch(postAddThirdPartySeatAction({ tenantId, authToken, userId, params, payload }))
                    .then(async (data) => {
                        const { responseCode: { msg, status = '' }, responseObj } = data;
                        if (isApiCallSuccess(status)) {
                            if (isPlatformMeta) {
                                let pages = thirdPartyAccount.account['pages'] && thirdPartyAccount['account']['pages'].length > 0 ? thirdPartyAccount['account']['pages'] : [];
                                console.log(pages, 'PAGES');
                                let addedPages = pages.filter(page => page.isRecActive == 1);
                                let removedPages = pages.filter(page => page.isRecActive == 0);
                                let editedSeatPageIds = resignInSeatData.pages.map(page => page['pageId']);
                                addedPages = addedPages.filter(page => !editedSeatPageIds.includes(page.id));
                                let addMap = {
                                    [tenantId]: addedPages.map(page => ({
                                        pageId: page.id,
                                        pageName: page['name']
                                    }))
                                };
                                let removeMap = {
                                    [tenantId]: removedPages.map(page => ({
                                        pageId: page.id,
                                        pageName: page['name']
                                    }))
                                };
                                let request = {
                                    pageAccessRequest: {
                                        addMap,
                                        removeMap,
                                        accountId: resignInSeatData.accountId,
                                        platformId: resignInSeatData.platformId
                                    }
                                };
                                await updateMetaSeatPages(request);
                            }
                            dispatch(
                                thirdPartyAccountAction({
                                    thirdPartyAccount: {}
                                })
                            );
                            toast(status, msg);
                            setAccounts([]);
                            setForm({ status: 1 });
                            onSave();
                        } else {
                            toast('error', msg);
                        }
                    }).catch((error) => {
                        console.error(error);
                    });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const findPlatform = (platforms, key) => {
        try {
            if (Array.isArray(platforms)) {
                const platform = platforms.find(item => item.key == key);
                return platform ? platform.value : '';
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getPages = (account) => {
        try {
            if (!account || Object.keys(account).length == 0 || Object.keys(account).length == 1) return true;
            let pages = account && account.pages ? account.pages : [];
            if (pages.length > 0) {
                if (pages.every(page => !page.hasOwnProperty('isRecActive'))) return true;
                return pages.every(page => page['isRecActive'] === 0);
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    const isSaveButtonDisabled = () => {
        try {
            if (platformData && platformData.length > 0) {
                const platform = findPlatform(platformData, form[formFields.platform.key]);
                const isPlatformMatch = platform.toLowerCase() == platformConfig.meta.toLowerCase();
                const arePagesSelected = getPages(thirdPartyAccount['account']);

                if (thirdPartyAccount && Object.keys(thirdPartyAccount).length > 0 && validateThirdPartyAccount()) {
                    if (isPlatformMatch)
                        return arePagesSelected;
                    else
                        return false;
                } else {
                    return true;
                }
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    const validateThirdPartyAccount = () => {
        try {
            let platform = platformData.find(item => item.key == resignInSeatData.platformId);
            if (platform && platform.value == platformConfig.google || platform.value == platformConfig.dv360) {
                let accountDetails = thirdPartyAccount.account;
                if (accountDetails['masterAccountId'] == resignInSeatData['masterAccountId']) {
                    if (accountDetails['accountId'] == resignInSeatData['accountId']) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else if (platform && platform.value == platformConfig.meta) {
                let accountDetails = thirdPartyAccount.account;
                if (accountDetails['accountId'] == resignInSeatData['accountId']) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const { history, match } = props;
        if (/[?&]/.test(window.location.href)) {
            localStorage.setItem("thirdPartyCallbackUrl", JSON.stringify(window.location.href));
            if (localStorage.getItem("thirdPartyCallbackUrl")) {
                history.push(`${match.path}`);
            }
        }

        if (resignInSeatData) {
            setForm({ ...form, platform: resignInSeatData.platformId });
        }

        setTimeout(() => {
            let url = JSON.parse(localStorage.getItem("thirdPartyCallbackUrl"));
            if (url && !url.includes("access_denied") && url.includes("code") && localStorage.getItem('thirdPartyLoginData')) {
                // console.log(url);
                handleVerification(url);
            } else {
                localStorage.removeItem('thirdPartyLoginData');
                localStorage.removeItem('thirdPartyCallbackUrl');
            }
        }, 300);
    }, []);

    useEffect(() => {
        if (thirdPartyAccount && thirdPartyAccount['account'] && Object.keys(thirdPartyAccount['account']).length > 1) {
            if (!validateThirdPartyAccount()) {
                toast('error', "Please be informed that the account credentials entered do not correspond to the account currently awaiting activation. Kindly ensure that you are using the correct login information for the intended account.");
            }
        }
    }, [thirdPartyAccount])

    return (
        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    // path={routes.containers.admin + '/' + routes.admin.account.name}
                    idProps={props}
                    poc={true}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    outSideClickEnable={false}
                />
            }
            <div className='my-4 p-0'>
                <div className="card">
                    <div className="p-4 m-2">
                        <div className='row'>
                            <div className="col-md-6">
                                <SelectNew
                                    onChange={(e) => {
                                        handleChange(e);
                                        setAccounts([]);
                                    }}
                                    onBlur={handleTouch}
                                    value={form[formFields.platform.key]}
                                    setting={formFields[formFields.platform.key]}
                                    error={errors[formFields.platform.key]}
                                    submited={submited}
                                    touched={touched[formFields.platform.key]}
                                    options={platformData}
                                    disabled={true}
                                />
                            </div>

                            <div className="col-md-6">
                                <SelectNew
                                    onChange={handleChange}
                                    onBlur={handleTouch}
                                    value={form[formFields.status.key]}
                                    setting={formFields[formFields.status.key]}
                                    error={errors[formFields.status.key]}
                                    submited={submited}
                                    touched={touched[formFields.status.key]}
                                    options={statusOptions}
                                />
                            </div>
                        </div>

                        <div className="w-full">
                            <button disabled={form[formFields.platform.key] ? false : true} onClick={() => generatePlatformUrl()} className="btn btn-primary rounded-2 w-100" style={{ backgroundColor: '#383890', padding: '0.825rem 0rem' }}>
                                <span className="text-white" style={{ fontSize: 14 }}>Map Account</span>
                            </button>
                        </div>

                    </div>


                    {
                        accounts && accounts.length > 0 ?
                            <PlatformAccount key={index} selectAdvertisers={false} accounts={accounts} platformData={platformData} platformKey={form[formFields.platform.key]} props={props} resignInSeatData={resignInSeatData} />
                            :
                            null
                    }
                </div>


                <div className="col-md-12 py-4 d-flex border justify-content-end" style={{ background: '#F7F8FC', borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                    <button onClick={() => saveMappedThirdPartyAccount()}
                        // disabled={isSaveButtonDisabled()} 
                        className="btn rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                        <span className="text-white">Save</span>
                    </button>

                    <button onClick={() => {
                        dispatch(
                            thirdPartyAccountAction({
                                thirdPartyAccount: {}
                            })
                        );
                        onClose();
                    }} className="btn mx-3" style={{ borderRadius: '0.5rem', border: '1px solid #DCE3EE', background: '#FFF', padding: '0.625rem 1.125rem' }}>
                        <span className="text-primary">Close</span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default withRouter(index);